// extracted by mini-css-extract-plugin
module.exports = {"title":"for-advertisers-module--title--21qAP","body":"for-advertisers-module--body--15qo4","promotions":"for-advertisers-module--promotions--3u1fj"};